import { API_BASE_URL } from "src/config/apiBase";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { parseThemeApiResponse, themeAdminUrl } from "./themeApiUtils";

const ThemeUploadModal = ({ token, theme, isVersion, onClose, onSaved }) => {
  const urlmain = API_BASE_URL;
  const [form, setForm] = useState({
    name: theme?.name || "",
    slug: theme?.slug || "",
    description: theme?.description || "",
    version: "",
    release_notes: "",
  });
  const [thumbnail, setThumbnail] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = new FormData();
      if (!isVersion) {
        body.append("name", form.name);
        body.append("slug", form.slug);
        body.append("description", form.description);
      }
      body.append("version", form.version);
      body.append("release_notes", form.release_notes);
      if (thumbnail) body.append("thumbnail", thumbnail);

      const url = isVersion
        ? themeAdminUrl(`/${theme.id}/versions`)
        : themeAdminUrl();

      const response = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body,
      });
      const res = await parseThemeApiResponse(response);
      if (response.ok && !res.isError) {
        toast.success(res.message);
        onSaved();
      } else {
        toast.error(res.message || "Save failed");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 9999 }}>
      <div
        className="modal-content"
        style={{
          background: "#fff",
          maxWidth: 520,
          margin: "80px auto",
          padding: 24,
          borderRadius: 8,
        }}
      >
        <h2>{isVersion ? `Upload update — ${theme.name}` : "Upload theme"}</h2>
        <form onSubmit={handleSubmit}>
          {!isVersion && (
            <>
              <label>Name</label>
              <input name="name" value={form.name} onChange={handleChange} required style={{ width: "100%", marginBottom: 12 }} />
              <label>Slug</label>
              <input name="slug" value={form.slug} onChange={handleChange} required style={{ width: "100%", marginBottom: 12 }} />
              <label>Description</label>
              <textarea name="description" value={form.description} onChange={handleChange} rows={3} style={{ width: "100%", marginBottom: 12 }} />
            </>
          )}
          <label>Version</label>
          <input name="version" value={form.version} onChange={handleChange} required placeholder="1.0.0" style={{ width: "100%", marginBottom: 12 }} />
          <label>Release notes</label>
          <textarea name="release_notes" value={form.release_notes} onChange={handleChange} rows={3} style={{ width: "100%", marginBottom: 12 }} />
          <label>Thumbnail</label>
          <input type="file" accept="image/*" onChange={(e) => setThumbnail(e.target.files?.[0] || null)} style={{ marginBottom: 16 }} />
          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="oms-add-btn" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ThemeUploadModal;
